"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_caption.scss");

function Caption(a) {
  var b = a.defaultLanguage,
      c = a.onDelete,
      d = a.onChange,
      e = a.label,
      f = a.selectedCaptions,
      g = a.disabled,
      h = a.type,
      i = a.CAPTIONS,
      j = i(h),
      k = j.filter(function (a) {
    return !f.includes(a.value);
  });
  return _react["default"].createElement("div", {
    className: "caption"
  }, _react["default"].createElement(_uiKit.Dropdown, {
    options: k,
    onChange: d,
    defaultValue: b && j.find(function (a) {
      return a.value === b.value;
    }),
    placeholder: "Select a caption",
    label: e,
    hideSeparators: !0,
    showSelectedSuffix: !0,
    disabled: g,
    type: "BUTTON"
  }), c && !g ? _react["default"].createElement(_uiKit.Button, {
    prefix: "trash",
    onClick: c,
    type: "TERTIARY"
  }) : null);
}

var _default = (0, _react.memo)(Caption);

exports["default"] = _default;